"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformSessionEventAction = exports.InformSessionEventAuthorType = void 0;
var InformSessionEventAuthorType;
(function (InformSessionEventAuthorType) {
    InformSessionEventAuthorType["System"] = "System";
    InformSessionEventAuthorType["User"] = "User";
    InformSessionEventAuthorType["ClinicPetParent"] = "ClinicPetParent";
})(InformSessionEventAuthorType = exports.InformSessionEventAuthorType || (exports.InformSessionEventAuthorType = {}));
var InformSessionEventAction;
(function (InformSessionEventAction) {
    InformSessionEventAction["TrupanionExamDayOfferSubmitted"] = "trupanion-edo.submitted";
    InformSessionEventAction["TrupanionExamDayOfferActivated"] = "trupanion-edo.activated";
})(InformSessionEventAction = exports.InformSessionEventAction || (exports.InformSessionEventAction = {}));
//# sourceMappingURL=CreateInformSessionEventJobInput.js.map